import CollabArrowsIcon from "~vue/icons/CollabArrowsIcon.vue";
import CollabAsteriskIcon from "~vue/icons/CollabAsteriskIcon.vue";
import CollabCircleIcon from "~vue/icons/CollabCircleIcon.vue";
import CollabCircleSquareIcon from "~vue/icons/CollabCircleSquareIcon.vue";
import CollabCommunicationStyleIcon from "~vue/icons/CollabCommunicationStyleIcon.vue";
import CollabDecisionMakingIcon from "~vue/icons/CollabDecisionMakingIcon.vue";
import CollabFeedbackCollaborationIcon from "~vue/icons/CollabFeedbackCollaborationIcon.vue";
import CollabInformationProcessingIcon from "~vue/icons/CollabInformationProcessingIcon.vue";
import CollabMotivatorsStressorsIcon from "~vue/icons/CollabMotivatorsStressorsIcon.vue";
import CollabRectanglesIcon from "~vue/icons/CollabRectanglesIcon.vue";
import CollabSquaresIcon from "~vue/icons/CollabSquaresIcon.vue";
import CollabStarIcon from "~vue/icons/CollabStarIcon.vue";
import CollabTriangleIcon from "~vue/icons/CollabTriangleIcon.vue";
import CollabTrianglesIcon from "~vue/icons/CollabTrianglesIcon.vue";
import CollabWorkStructureIcon from "~vue/icons/CollabWorkStructureIcon.vue";
import { type Component, markRaw } from "vue";

export interface CollabIcon {
    component: Component;
    color: string;
    // The retained artwork uses lighter fills than its list markers.
    markerColor?: string;
}

export const COLLAB_ICONS = {
    // Named assets from https://designsystemtonal.vercel.app/#icons, applied in both themes.
    communicationStyle: { component: markRaw(CollabCommunicationStyleIcon), color: "var(--tonal-pink-strong)" },
    decisionMaking: { component: markRaw(CollabDecisionMakingIcon), color: "var(--tonal-purple-strong)" },
    informationProcessing: { component: markRaw(CollabInformationProcessingIcon), color: "var(--tonal-green-base)" },
    workStructure: { component: markRaw(CollabWorkStructureIcon), color: "var(--tonal-orange-base)" },
    feedbackCollaboration: { component: markRaw(CollabFeedbackCollaborationIcon), color: "var(--tonal-teal-base)" },
    motivatorsStressors: { component: markRaw(CollabMotivatorsStressorsIcon), color: "var(--tonal-orange-strong)" },
    circleSquare: { component: markRaw(CollabCircleSquareIcon), color: "#CBCDF7", markerColor: "#9B9EE0" },
    squares: { component: markRaw(CollabSquaresIcon), color: "#D0F3C9", markerColor: "#9BCF8A" },
    arrows: { component: markRaw(CollabArrowsIcon), color: "#A1A5FD", markerColor: "#7A7FDB" },
    triangles: { component: markRaw(CollabTrianglesIcon), color: "#FFE299", markerColor: "#E6C866" },
    rectangles: { component: markRaw(CollabRectanglesIcon), color: "#91D3E1", markerColor: "#6BB5C7" },
    asterisk: { component: markRaw(CollabAsteriskIcon), color: "#16C2C3", markerColor: "#0F9A9B" },
    // Retain the preview illustration's glyphs and the unknown-subtopic fallback.
    star: { component: markRaw(CollabStarIcon), color: "#F4298F" },
    circle: { component: markRaw(CollabCircleIcon), color: "#95C587", markerColor: "#6B9B5F" },
    triangle: { component: markRaw(CollabTriangleIcon), color: "#FFDEB4", markerColor: "#D4B88A" },
} as const satisfies Record<string, CollabIcon>;

export const SUBTOPIC_ICONS: Record<string, CollabIcon> = {
    "Communication Style": COLLAB_ICONS.communicationStyle,
    "Decision-Making Style": COLLAB_ICONS.decisionMaking,
    "Information Processing": COLLAB_ICONS.informationProcessing,
    "Work Structure": COLLAB_ICONS.workStructure,
    "Feedback & Collaboration": COLLAB_ICONS.feedbackCollaboration,
    "Motivators & Stressors": COLLAB_ICONS.motivatorsStressors,
    "What goals really matter to me right now": COLLAB_ICONS.circleSquare,
    "When I've seen teams at their best, what was happening": COLLAB_ICONS.squares,
    "One thing that erodes trust with me quickly": COLLAB_ICONS.arrows,
    "What impresses me in a direct report": COLLAB_ICONS.triangles,
    "How and when I want to learn about issues": COLLAB_ICONS.rectangles,
    "Working agreements I try to hold us to": COLLAB_ICONS.asterisk,
};

export const DEFAULT_ICON = COLLAB_ICONS.circle;
